require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconDarkMode.tsx
var IconDarkMode_exports = {};
__export(IconDarkMode_exports, {
  default: () => IconDarkMode_default
});
module.exports = __toCommonJS(IconDarkMode_exports);

// src/assets/monochrome/darkMode.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgDarkMode = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.10469 3.67788C7.47923 3.86535 6.88167 4.1456 6.33285 4.51231C5.24749 5.23752 4.40155 6.2683 3.90201 7.4743C3.40247 8.68029 3.27177 10.0073 3.52643 11.2876C3.78109 12.5679 4.40968 13.7439 5.33271 14.6669C6.25573 15.5899 7.43174 16.2185 8.71202 16.4732C9.99229 16.7279 11.3193 16.5971 12.5253 16.0976C13.7313 15.5981 14.7621 14.7521 15.4873 13.6668C15.854 13.118 16.1343 12.5204 16.3217 11.8949C15.5217 12.2594 14.6457 12.4533 13.7496 12.4533C12.1044 12.4533 10.5266 11.7997 9.36322 10.6364C8.19987 9.47306 7.54631 7.89522 7.54631 6.25001C7.54631 5.35395 7.74018 4.47788 8.10469 3.67788ZM5.33282 3.01566C6.7142 2.09266 8.33825 1.60001 9.99961 1.60001C10.3636 1.60001 10.6918 1.81928 10.8311 2.15559C10.9704 2.4919 10.8934 2.879 10.636 3.1364C9.81023 3.96218 9.34631 5.08218 9.34631 6.25001C9.34631 7.41783 9.81023 8.53783 10.636 9.36361C11.4618 10.1894 12.5818 10.6533 13.7496 10.6533C14.9174 10.6533 16.0374 10.1894 16.8632 9.36361C17.1206 9.10621 17.5077 9.02921 17.844 9.16851C18.1803 9.30782 18.3996 9.63599 18.3996 10C18.3996 11.6614 17.907 13.2854 16.984 14.6668C16.061 16.0482 14.7491 17.1248 13.2142 17.7606C11.6793 18.3964 9.9903 18.5627 8.36086 18.2386C6.73141 17.9145 5.23468 17.1145 4.05992 15.9397C2.88515 14.7649 2.08513 13.2682 1.76102 11.6388C1.4369 10.0093 1.60325 8.32036 2.23903 6.78547C2.8748 5.25057 3.95145 3.93867 5.33282 3.01566ZM16.6663 1.60001C17.1633 1.60001 17.5663 2.00295 17.5663 2.50001V3.26667H18.3329C18.83 3.26667 19.2329 3.66962 19.2329 4.16667C19.2329 4.66373 18.83 5.06667 18.3329 5.06667H17.5663V5.83334C17.5663 6.3304 17.1633 6.73334 16.6663 6.73334C16.1692 6.73334 15.7663 6.3304 15.7663 5.83334V5.06667H14.9996C14.5026 5.06667 14.0996 4.66373 14.0996 4.16667C14.0996 3.66962 14.5026 3.26667 14.9996 3.26667H15.7663V2.50001C15.7663 2.00295 16.1692 1.60001 16.6663 1.60001Z", fill: "#818898" }) });
var darkMode_default = SvgDarkMode;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconDarkMode.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconDarkMode = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(darkMode_default, {}) });
};
IconDarkMode.displayName = "IconDarkMode";
var IconDarkMode_default = IconDarkMode;
